import React from 'react';

const InstallExtensionIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4fa3ff" strokeWidth={2}>
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
);

export default InstallExtensionIcon;